module.exports = "https://static.im-cdn.com/mjc/storefront/Esteem/static/media/Google.27207391.svg";